import React from "react";
import PropTypes from "prop-types";
import { LogOut, UserCog } from "lucide-react";

import { useTranslation } from "../../context/Internationalization";
import TranslationToggle from "../TranslationToggle";
import { useRunAfterMenuClose } from "../Modal/dialogHelpers";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../shadcn/components/ui/dropdown-menu";

// Account menu with its own trigger. `trigger` is the element the menu opens
// from (passed to Base UI `render`), `children` its content.
const AccountMenu = ({
  trigger,
  triggerProps,
  children,
  onOpenSettings,
  onLogout,
  showSettings = true,
  side = "bottom",
  align = "end",
  contentClassName,
}) => {
  const { t } = useTranslation();
  const { runAfterClose, onOpenChangeComplete } = useRunAfterMenuClose();

  return (
    <DropdownMenu onOpenChangeComplete={onOpenChangeComplete}>
      <DropdownMenuTrigger render={trigger} {...triggerProps}>
        {children}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        aria-label={t("account_menu")}
        side={side}
        align={align}
        sideOffset={4}
        className={contentClassName || "w-auto min-w-56"}
      >
        {showSettings && (
          <DropdownMenuItem onClick={() => runAfterClose(onOpenSettings)}>
            <UserCog aria-hidden="true" />
            {t("account_settings")}
          </DropdownMenuItem>
        )}
        <TranslationToggle menuItem />
        <DropdownMenuSeparator />
        <DropdownMenuItem
          variant="destructive"
          onClick={() => runAfterClose(onLogout)}
        >
          <LogOut aria-hidden="true" />
          {t("logout")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

AccountMenu.propTypes = {
  trigger: PropTypes.element,
  triggerProps: PropTypes.object,
  children: PropTypes.node,
  onOpenSettings: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  showSettings: PropTypes.bool,
  side: PropTypes.string,
  align: PropTypes.string,
  contentClassName: PropTypes.string,
};

export default AccountMenu;
